import {Injectable, TemplateRef} from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ToastService {
    toasts: any[] = [];
    notification: any[] = [];
    newNotification = 0;

    constructor() {
    }

    show(textOrTpl: string | TemplateRef<any>, options: any = {}): void {
        this.toasts.push({textOrTpl, ...options});
        this.notification.unshift({textOrTpl, ...options, isNew: true});
        const audio: HTMLAudioElement = new Audio('../../../assets/audio/notification2.wav');
        audio.volume = 0.4;
        void audio.play();
        this.newNotification = this.notification.filter(x => x.isNew).length;
    }

    remove(toast): void {
        this.toasts = this.toasts.filter((t) => t !== toast);
    }

    clear(): void {
        this.toasts.splice(0, this.toasts.length);
    }
}
